import type {RouteMap} from '@gl/app/lit/types/routes.js';

export const routes: RouteMap = {
  all: {
    paths: ['*'],
    components: {
      interface: () =>
        import(
          /* webpackChunkName: "interface" */
          './interface.js'
        ),
      global: () =>
        import(
          /* webpackChunkName: "global" */
          './global.js'
        ),
    },
  },
  audiences: {
    paths: ['/audiences'],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "audiences" */
          './audiences.js'
        ),
    },
  },
  audienceBuilder: {
    paths: [
      '/v2/dataset_groups/:dataset_group_id/audiences/new',
      '/v2/dataset_groups/:dataset_group_id/audiences/:id',
      '/v2/dataset_groups/:dataset_group_id/audiences/:id/edit',
    ],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "audience_builder_v2" */
          './audience_builder.js'
        ),
    },
  },
  schemaBuilder: {
    paths: ['/dataset_groups/:dataset_group_id/edit', '/dataset_groups/new'],
    components: {
      schemaBuilderComponents: () =>
        import(
          /* webpackChunkName: "data_manager" */
          './data_manager.js'
        ),
    },
  },
  designSystem: {
    paths: ['/internal/design_system'],
    components: {
      designSystemComponent: () =>
        import(
          /* webpackChunkName: "internal_ds" */
          './design_system.js'
        ),
    },
  },
  journeyBuilder: {
    paths: [
      '/v2/journeys/new',
      '/v2/journeys/:id',
      '/v2/journeys/:id/edit',
      '/v2/dataset_groups/:dataset_group_id/journeys/:id',
      '/v2/dataset_groups/:dataset_group_id/journeys/:id/edit',
      '/v2/dataset_groups/:dataset_group_id/journey_builder/:id/edit',
    ],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "journey_builder_v2" */
          './journey_builder.js'
        ),
    },
  },
  journeys: {
    paths: ['/v2/journeys'],
    components: {
      journeysComponents: () =>
        import(
          /* webpackChunkName: "journeys" */
          './journeys.js'
        ),
    },
  },
  onboarding: {
    paths: ['/onboarding'],
    components: {
      onboardingComponents: () =>
        import(
          /* webpackChunkName: "onboarding" */
          './onboarding.js'
        ),
    },
  },
  destinations: {
    paths: [
      '/destination_platforms',
      '/teams/:team_id/destination_platforms/:id/edit',
    ],
    components: {
      destinationComponents: () =>
        import(
          /* webpackChunkName: "destinations" */
          './destinations.js'
        ),
    },
  },
  sources: {
    paths: ['/import_sources'],
    components: {
      sourceComponents: () =>
        import(
          /* webpackChunkName: "sources" */
          './sources.js'
        ),
    },
  },
  accessGrants: {
    paths: ['/v2/access_grants'],
    components: {
      accessGrantsComponents: () =>
        import(
          /* webpackChunkName: "access_grants" */
          './access_grants.js'
        ),
    },
  },
  adminOrganizations: {
    paths: ['/admin/organizations', '/admin/organizations/:id/edit'],
    components: {
      adminOrganizationsComponents: () =>
        import(
          /* webpackChunkName: "admin_organizations" */
          './admin_organizations.js'
        ),
    },
  },
  teams: {
    paths: ['/teams/:id/edit'],
    components: {
      teamsComponents: () =>
        import(
          /* webpackChunkName: "admin_teams" */
          './teams.js'
        ),
    },
  },
  marve: {
    paths: ['/v2/create'],
    components: {
      marve: () =>
        import(
          /* webpackChunkName: "marve" */
          './marve.js'
        ),
    },
  },
  home: {
    paths: ['/home'],
    components: {
      home: () =>
        import(
          /* webpackChunkName: "home" */
          './home.js'
        ),
    },
  },
  insights: {
    paths: ['/insights', '/insights/:id'],
    components: {
      insights: () =>
        import(
          /* webpackChunkName: "insights" */
          './insights.js'
        ),
    },
  },
  organization: {
    paths: ['/organization'],
    components: {
      organizationComponents: () =>
        import(
          /* webpackChunkName: "organization" */
          './organization.js'
        ),
    },
  },
  embed: {
    paths: [
      '/embed/audiences/new',
      '/embed/audiences/:audience_id',
      '/embed/audiences/:audience_id/edit',
    ],
    components: {
      embedComponents: () => import('./embed.js'),
    },
  },
  reviewAudiences: {
    paths: ['/v2/review_audiences'],
    components: {
      reviewAudiencesComponents: () => import('./review_audiences.js'),
    },
  },
  queueEvents: {
    paths: ['/queue_events/new', '/queue_events/:id/edit'],
    components: {
      datasetsComponents: () =>
        import(
          /* webpackChunkName: "queue_events" */
          './queue_events.js'
        ),
    },
  },
  sourceConnections: {
    paths: ['/datasets/new', '/datasets/:id/edit', '/source_connections'],
    components: {
      datasetsComponents: () =>
        import(
          /* webpackChunkName: "datasets" */
          './datasets.js'
        ),
    },
  },
  signalRoutes: {
    paths: ['/signal_routes', '/signal_routes/:id/edit', '/signal_routes/:id'],
    components: {
      signalRoutesComponents: () =>
        import(
          /* webpackChunkName: "signal_routes" */
          './signal_routes.js'
        ),
    },
  },
  models: {
    paths: ['/models', '/models/new', '/models/:id/edit'],
    components: {
      modelsComponents: () =>
        import(
          /* webpackChunkName: "models" */
          './models.js'
        ),
    },
  },
};
